import DataQuery from 'library/util/query';

const outcomeQuery = async (outcome_id) => {
  return await DataQuery(`
    {
      outcome(id: ${Number(outcome_id)}) {
        id
        name
        description
        color

        goals {
          id
          name
          description
          steps_count

          icon {
            id
            category
            action
            filename
          }

          steps {
            id
            name
            description
          }
        }
      }
    }`);
};

export default outcomeQuery;
